import React, { Component } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Table, Button } from 'reactstrap'
import { Marker, Popup } from 'react-leaflet'
import foto_kapal from 'assets/img/kapal.jpg'
import { UPLOAD_URL } from '../../../actions/constant'
import { ID_REGULATOR } from 'actions/constant'
import { vesselRunPoint, vesselStopPoint } from './PointerIcon'

const userTypeId = localStorage.getItem('tolaut@typeUser')

class MarkerTracking extends Component {
  constructor(){
    super()
    this.state={
      light:''
    }
  }
  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);

    if (ribuan) {
      let separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }

    return rupiah
  }

  render() {
    return (
      <Marker position={(!this.props.data.lat || !this.props.data.lon) ? ['', ''] : [this.props.data.lat, this.props.data.lon]} icon={this.props.data.speed > 0 ? vesselRunPoint : vesselStopPoint}>
        <Popup>
          <div style={{width: '546px'}}>
            <Table striped responsive>
              <tbody>
                <tr>
                  <td colSpan="2" className="text-center">
                    <img src={this.props.data.photo ? UPLOAD_URL + this.props.data.photo : foto_kapal
                    } className="img-fluid mb-3 img-tracking" />
                    <h6>{this.props.data.name}</h6>
                  </td>
                </tr>
                <tr>
                  <td className="p-1"><h6><strong>Speed</strong></h6></td>
                  <td className="p-1">{this.props.data.speed} Knot</td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div style={{width: '546px'}} className="tbl-tracking overflow-auto">
          {this.props.data.schedules.length > 0 &&
            <Table responsive>
              <thead>
                <tr>
                  <th>Kode Trayek</th>
                  <th>Asal</th>
                  <th>Tujuan</th>
                  <th>ETD</th>
                  <th>ETA</th>
                  <th>ATD</th>
                  <th>ATA</th>
                  <th>Jumlah Muatan</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.props.data.schedules.map((item, key) => (
                  <tr style={this.state.light === key?{backgroundColor: '#aad3df'}:{}} className="highlight" onClick={()=>this.setState({light:key})} key={key}>
                    <td className="p-1">{item.kode_trayek}</td>
                    <td className="p-1">{item.dari_pelabuhan}</td>
                    <td className="p-1">{item.ke_pelabuhan}</td>
                    <td className="p-1">{item.tanggal_berangkat && moment(item.tanggal_berangkat).format('DD MMMM YYYY')}</td>
                    <td className="p-1">{item.tanggal_tiba && moment(item.tanggal_tiba).format('DD MMMM YYYY')}</td>
                    <td className="p-1">{item.atd && moment(item.atd).format('DD MMMM YYYY')}</td>
                    <td className="p-1">{item.ata && moment(item.atd).format('DD MMMM YYYY')}</td>
                    <td className="p-1">{item.total_muatan !== null ? this.changeRupiah(item.total_muatan) : 0}</td>
                    <td colSpan="2">
                      {parseInt(userTypeId) === parseInt(ID_REGULATOR) &&
                        // <Link to={"/vesseltracking/view/" + item.id}>
                          <Button size="md" color="success" className="mr-2 btn-block" onClick={async () => { await this.props.viewFunction(item.id); window.location.href=`/vesseltracking/view/${item.id}` }}>
                            Detail
                          </Button>
                        // </Link>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          }
          </div>
        </Popup>
      </Marker>
    )
  }
}

export default MarkerTracking
